import { Route } from "react-router-dom";
import WorkerJobs from "../components/index";

const WorkerJobsRoutes = () => (
  <>
    <Route path="/worker-jobs" element={<WorkerJobs />} />
  </>
);


export default WorkerJobsRoutes;